import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Input, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner'
import { PLAINTIFF_YEARS_QUERY } from '../../../graphql'
import { handleGraphQLErrors } from '../../../utils'

export const PLAINTIFF_YEARS = gql(PLAINTIFF_YEARS_QUERY)

export default function YearInput(props) {
  const { name, handleChange, selectLast, defaultValue } = props
  console.log('YearInput rendered', props)

  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: PLAINTIFF_YEARS, fetchPolicy: 'cache-first' })
        if (data.plaintiffYears) {
          const menuItems = []
          for (let item of data.plaintiffYears) {
            menuItems.push(<option key={item.id} value={item.id}>{item.name}</option>)
          }
          setItems(menuItems)
          if (selectLast) {
            handleChange({target: {name: name, value: menuItems[menuItems.length - 1].key}})
          } else {
            handleChange({target: {name: name, value: menuItems[0].key}})
          }
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  }, [handleChange, items, name, selectLast])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!items) {
    return <Spinner />
  } else {
    let selectedValue
    if (selectLast) {
      selectedValue = items[items.length - 1].key
    }
    if (defaultValue) {
      selectedValue=defaultValue
    }
    return (
      <Input style={{ display: 'inline-block', width: 'auto' }} type="select" name={name} defaultValue={selectedValue} onChange={handleChange}>
        {items}
      </Input>
    )
  }
}
